import React from 'react';
import { ContactActionIcon } from '@repo/icons';
import { SmallUppercaseText } from '@repo/components/typography';

export const ContactOptionsTrigger = ({ isOpen }) => (
  <ContactActionIcon width="24" height="24" isOpen={isOpen} hoverOpacity hover={false} />
);

export const BrowserExtensionContactOptionsTrigger = (_props: { isOpen?: boolean }) => (
  <>
    <ContactActionIcon color="textPrimary" width={24} height={24} hoverOpacity={false} />
    <SmallUppercaseText>Contact</SmallUppercaseText>
  </>
);
